import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Manifesto } from "@/components/site/Manifesto";
import { AITransform } from "@/components/site/AITransform";
import { Gallery } from "@/components/site/Gallery";
import { Method } from "@/components/site/Method";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0F0E0E] text-[#F5F2F0]" data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Manifesto />
      <Gallery />
      <AITransform />
      <Contact />
      <Method />
      <Faq />
      <Footer />
    </div>
  );
}
